<template>
  <div class="list-view content-layout bg-gray">
    <button class="btn btn-primary btn-fab show" @click="scrollToTop()">
      <font-awesome-icon :icon="['fas', 'angle-up']" class="align-middle" />
    </button>
    <button
      class="btn btn-primary list-side-menu-toggler"
      :class="{ expand: sideMenuExpanded }"
      @click="() => (sideMenuExpanded = !sideMenuExpanded)"
    >
      <font-awesome-icon :icon="['fas', sideMenuExpanded ? 'times' : 'bars']" />
    </button>
    <div
      class="list-side-menu"
      :class="{ expand: sideMenuExpanded, 'overflow-hidden': isLoadingOptions }"
    >
      <loading-spinner
        class="loading-spinner-component"
        style="position: fixed; max-width: 300px; left: 0px; top: 70px;"
        v-if="isLoadingOptions"
      />
      <div class="form-group">
        <label class="text-primary">
          <font-awesome-icon :icon="['fas', 'map-marker-alt']" class="mr-2 text-muted" />District
        </label>
        <v-select
          :clearable="false"
          placeholder="Select a district"
          class="report-filter"
          v-model="models.district"
          :options="options.district"
          @input="fetchSourceOptions"
          label="name"
        >
          <i slot="spinner" class="icon icon-spinner"></i>
        </v-select>
      </div>
      <div class="form-group">
        <label class="text-primary">
          <font-awesome-icon :icon="['fas', 'bolt']" class="mr-2 text-muted" />Source
        </label>
        <v-select
          :clearable="false"
          placeholder="Select a source"
          class="report-filter"
          v-model="models.source"
          :options="options.source"
          @input="fetchFeederOptions"
          label="name"
        ></v-select>
      </div>
      <div class="form-group">
        <label class="text-primary">
          <font-awesome-icon :icon="['fas', 'bolt']" class="mr-2 text-muted" />Category
        </label>
        <v-select
          :clearable="false"
          placeholder="Select a category"
          class="report-filter"
          v-model="models.category"
          :options="options.category"
          label="name"
        ></v-select>
      </div>
      <div class="form-group">
        <label class="text-primary">
          <font-awesome-icon :icon="['fas', 'bolt']" class="mr-2 text-muted" />Feeder
        </label>
        <v-select
          :clearable="false"
          placeholder="Select a feeder"
          class="report-filter"
          v-model="models.feeder"
          :options="
            options.feeder.length > 0 && models.category
              ? options.feeder.filter((f) => f.category == models.category.name)
              : []
          "
          @input="generateReport"
          label="name"
        ></v-select>
      </div>
    </div>
    <div id="tableContent" class="list-main-content position-relative">
      <div class="w-100 table-responsive small" v-if="tableData.length > 0">
        <table class="table table-striped table-bordered">
          <thead class="text-center bg-info">
            <tr>
              <th rowspan="2">Bil</th>
              <th rowspan="2">No Ruj.</th>
              <th rowspan="2">PMU/PPU</th>
              <th rowspan="2">PEMBEKAL</th>
              <th rowspan="2">
                JENIS PENCAWANG
                <br />PMU/PPU/SSU/PP/PE
              </th>
              <th rowspan="2">
                TAHAP VOLTAN
                <br />(kV)
              </th>
              <th rowspan="2">NAMA PMU/PPU/SSU/PP/PE</th>
              <th colspan="2">JENIS PENCAWANG</th>
              <th colspan="5">PMU/PPU/SSU/PP/PE PEMASANGAN PERALATAN</th>
              <th colspan="6">Keluasan Tanah/Saiz Tanah</th>
              <th rowspan="2">LOKASI</th>
              <th colspan="2">KOORDINAT GPS</th>
              <th rowspan="2">
                TELAH DISERAHKAN
                <br />DARIPADA PEMAJU
              </th>
              <th rowspan="2">
                DIPEROLEHI OLEH SESB
                <br />(TAHUN)
              </th>
              <th rowspan="2">
                JENIS TANAH DAN NO.
                <br />(JIKA ADA)
              </th>
              <th rowspan="2">NO. HAKMILIK</th>
              <th rowspan="2">
                SYARAT KEGUNAAN
                <br />(Dalam Geran)
              </th>
              <th rowspan="2">PREMIUM (RM)</th>
              <th rowspan="2">CUKAI TAHUNAN (RM)</th>
              <th rowspan="2">TEMPOH SAH GERAN</th>
              <th rowspan="2">TARIKH GERAN</th>
              <th colspan="2">KEADAAN SEMASA TAPAK</th>
              <th rowspan="2">
                Nyatakan Jika Bangunan Atas Tapak
                <br />Masih Digunakan Atau Tidak
              </th>
              <th rowspan="2">
                GAMBAR DI TAPAK
                <br />(External/ Internal)
              </th>
              <th rowspan="2">CATATAN</th>
            </tr>
            <tr>
              <th>POLE MOUNTED</th>
              <th>FLOOR MOUNTED</th>
              <th>VCB (Metered, Non-metered, Bus Section)</th>
              <th>SAIZ ALATUBAH (kVA) x NO.</th>
              <th>JENIS RMU x NO</th>
              <th>FEEDER PILLAR x NO</th>
              <th>LV Outgoing (No. PEMBEKAL LV)</th>
              <th>10' x 10'</th>
              <th>20' x 20'</th>
              <th>40' x 40'</th>
              <th>Single Chamber (55' x 45')</th>
              <th>Double Chamber (65' x 45')</th>
              <th>Lain-Lain</th>
              <th>LATITUDE</th>
              <th>LONGITUDE</th>
              <th>TANAH KOSONG</th>
              <th>TANAH DENGAN BANGUNAN (NYATAKAN)</th>
            </tr>
          </thead>
          <tbody class="text-center">
            <tr v-for="(d, index) in tableData" :key="d._id">
              <td>{{index + 1}}</td>
              <td>TWU/PE/{{generateNoRuj(d.name)}}</td>
              <td>{{models.source.name}}</td>
              <td></td>
              <td>{{getJenisPencawang(models.source.name)}}</td>
              <td>{{models.category.name}}</td>
              <td>{{models.source.name}}</td>
              <td></td>
              <td>&check;</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>N{{getCoordShort(d.lat)}}</td>
              <td>E{{getCoordShort(d.lng)}}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>DIGUNAKAN</td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api.js";
import LoadingSpinner from "@/components/LoadingSpinner";

export default {
  name: "erms",
  components: {
    "loading-spinner": LoadingSpinner,
  },
  data() {
    return {
      sideMenuExpanded: false,
      isLoadingOptions: false,
      options: {
        district: [],
        source: [],
        category: [],
        feeder: [],
      },
      models: {
        district: null,
        source: null,
        category: null,
        feeder: null,
      },
      tableData: [],
    };
  },
  methods: {
    getCoordShort(coord) {
      if (coord) {
        return coord.toFixed(6);
      } else {
        return "";
      }
    },
    generateNoRuj(name) {
      if (name) {
        let no = name.trim().split(" ")[0];
        return no;
      } else {
        return "";
      }
    },
    getJenisPencawang(name) {
      if (name) {
        let jenis = name.trim().split(" ")[0];
        return jenis;
      } else {
        return "";
      }
    },
    scrollToTop() {
      document.getElementById("tableContent").scrollTop = 0;
    },
    async fetchDistrictOptions() {
      this.isLoadingOptions = true;
      this.tableData = [];
      this.options.district = [];
      this.options.source = [];
      this.options.category = [];
      this.options.feeder = [];
      this.models.district = null;
      this.models.source = null;
      this.models.category = null;
      this.models.feeder = null;

      let url = `places?_limit=-1&type=District&place.name=Sabah`;

      API.get(url)
        .then((retVal) => {
          this.options.district = retVal.data.map((d) => {
            return { _id: d._id, name: d.name };
          });
          this.isLoadingOptions = false;
        })
        .catch((err) => {
          console.error(err);
          this.isLoadingOptions = false;
        });
    },
    async fetchSourceOptions() {
      this.isLoadingOptions = true;
      this.tableData = [];
      this.options.source = [];
      this.options.category = [];
      this.options.feeder = [];
      this.models.source = null;
      this.models.category = null;
      this.models.feeder = null;

      let url = `places?_limit=-1&type=Source&place=${this.models.district._id}`;

      API.get(url)
        .then((retVal) => {
          this.options.source = retVal.data.map((d) => {
            return { _id: d._id, name: d.name };
          });
          this.isLoadingOptions = false;
        })
        .catch((err) => {
          console.error(err);
          this.isLoadingOptions = false;
        });
    },
    async fetchFeederOptions() {
      this.isLoadingOptions = true;
      this.tableData = [];
      this.options.category = [];
      this.options.feeder = [];
      this.models.category = null;
      this.models.feeder = null;

      let url = `places?_limit=-1&type=Feeder&place=${this.models.source._id}`;

      API.get(url)
        .then((retVal) => {
          this.options.category = retVal.data.map((d) => {
            return { _id: d._id, name: d.category };
          });
          retVal.data.forEach((d) => {
            let f = this.options.category.find((c) => c.name == d.category);
            if (!f) {
              this.options.category.push({ _id: d._id, name: d.category });
            }
          });

          this.options.feeder = retVal.data.map((d) => {
            return {
              _id: d._id,
              name: d.name,
              category: d.category,
              inspection: d.inspections[0],
            };
          });

          this.isLoadingOptions = false;
        })
        .catch((err) => {
          console.error(err);
          this.isLoadingOptions = false;
        });
    },
    generateReport() {
      this.$emit("isLoading", true);

      let url = `report/${this.models.feeder.inspection._id}`;

      API.get(url)
        .then((retVal) => {
          this.getPoleReports(retVal.data);

          this.$nextTick(() => {
            this.scrollToTop();
          });

          this.$emit("isLoading", false);
        })
        .catch((err) => {
          console.error(err);
          this.$emit("isLoading", false);
        });
    },
    getPoleReports(poles) {
      poles.sort((a, b) => {
        let aNum = parseInt(a.name.split(" ")[0]);
        let bNum = parseInt(b.name.split(" ")[0]);

        return aNum - bNum;
      });

      this.tableData = poles;
    },
  },
  async mounted() {
    await this.fetchDistrictOptions();
  },
};
</script>